import isOptOut from './isOptOut.js';
const getDefaultTrackingPreference = (region, config) => {
  // In opt in regions, we only allow required trackers
  if (!isOptOut(region)) {
    const categories = config.categories.map(c => {
      if (c.required) return c.id;
    }).filter(c => !!c);
    return {
      region,
      consent: categories
    };
  }

  // In all other regions, we allow all trackers by default
  const categories = config.categories.map(c => c.id).filter(id => id !== 'delete-if-seen');
  return {
    region,
    consent: categories
  };
};
export { getDefaultTrackingPreference as default };
//# sourceMappingURL=getDefaultTrackingPreference.js.map
